import { Component, Input } from '@angular/core';

const DEFAULT_ICON_SIZE = 24;

@Component({
  selector: 'app-settings-icon',
  standalone: true,
  templateUrl: './settings-icon.component.html'
})
export class SettingsIconComponent {
  @Input() size?: number = DEFAULT_ICON_SIZE;
  @Input() width?: number;
  @Input() height?: number;
}
